<template>
    <modal-dialog
        id="new-user"
        :show.sync="shown"
    >
        <template v-slot:title>
            Add a Staff Member
        </template>
        <div class="uk-panel">
            <form class="uk-form" role="form" @submit.prevent.stop="create">
                <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                    <div class="uk-width-2-5">
                        <form-input
                            id="new-user-email"
                            v-model="user.email"
                            name="email"
                            :error="has_error('email')"
                            :required="true"
                            :editable="true"
                            width="1-1"
                            placeholder="Email"
                            class="uk-width-1-1"
                        />
                    </div>
                    <div class="uk-width-2-5">
                        <form-password
                            id="new-user-password"
                            v-model="user.password"
                            name="password"
                            :error="has_error('password')"
                            :required="false"
                            :editable="true"
                            width="1-1"
                            placeholder="Password"
                        />
                    </div>
                    <div class="uk-width-1-5">
                        <form-select
                            id="new-user-studio"
                            name="studio_id"
                            v-model="user.studio_id"
                            :options="studios"
                            empty-label="(Pick one)"
                            :editable="true"
                            :required="true"
                            class="uk-width-1-1"
                        />
                    </div>
                </div>

                <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                    <div class="uk-width-2-5">
                        <form-input
                            id="new-user-first-name"
                            v-model="user.first_name"
                            name="first_name"
                            :error="has_error('first_name')"
                            :required="true"
                            :editable="true"
                            width="1-1"
                            placeholder="First Name"
                            class="uk-width-1-1"
                        />
                    </div>
                    <div class="uk-width-2-5">
                        <form-input
                            id="new-user-last-name"
                            v-model="user.last_name"
                            name="last_name"
                            :error="has_error('last_name')"
                            :required="true"
                            :editable="true"
                            width="1-1"
                            placeholder="Last Name"
                            class="uk-width-1-1"
                        />
                    </div>
                    <div class="uk-width-1-5">
                        <form-input
                            id="new-user-initials"
                            v-model="user.initials"
                            name="initials"
                            :error="has_error('initials')"
                            :required="true"
                            :editable="true"
                            width="1-1"
                            placeholder="Initials"
                            class="uk-width-1-1"
                        />
                    </div>
                </div>

                <div class="uk-modal-footer uk-text-center">
                    <div class="uk-grid">
                        <div class="uk-width-1-2">
                            <base-button
                                size="large"
                                width="1-1"
                                :disabled="creating"
                                @click.prevent="close"
                                class="uk-width-1-1"
                            >
                                Cancel
                            </base-button>
                        </div>
                        <div class="uk-width-1-2">
                            <base-button
                                type="submit"
                                size="large"
                                color="primary"
                                width="1-1"
                                :waiting="creating"
                                :disabled="creating"
                                class="uk-width-1-1"
                            >
                                Save
                            </base-button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </modal-dialog>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

// import ui_utilities from "../mixins/UiUtilities"
// import string_utilities from "../mixins/StringUtilities"
import handles_errors from "../mixins/HandlesErrors"

import ModalDialog from "./ModalDialog/ModalDialog"
import FormInput from "../ui/FormInput"
import FormPassword from "../ui/FormPassword"
import FormSelect from "../ui/FormSelect"
import BaseButton from "../ui/BaseButton"

export default {
    mixins: [handles_errors],
    components: {
        ModalDialog,
        FormInput,
        FormPassword,
        FormSelect,
        BaseButton
    },
    mounted () {
        this.reset_data()
    },
    watch: {
        show: "maybe_reset_data"
    },
    methods: {
        reset_data () {
            this.user.email = ""
            this.user.first_name = ""
            this.user.last_name = ""
            this.user.initials = ""
            this.user.studio_id = 1
            this.user.password = ""
        },
        maybe_reset_data () {
            if(this.show) this.reset_data()
        },
        create () {
            this.creating = true

            this.$store.dispatch("CREATE_RECORD", {
                entity: "user",
                data: this.user
            }).then(record => {
                if(record.id) {
                    this.$router.push({
                        name: "user.edit",
                        params: { id: record.id }
                    })
                    this.close()
                }
            }).catch(this.receive_error).then(() => {
                this.creating = false
            })
        },
        close () {
            this.$emit("update:show", false)
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        studios () {
            return this.entity_records("studio")
        },
        shown: {
            get: function () {
                return this.show
            },
            set: function (show) {
                if(!show) this.close()
            }
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            creating: false,
            user: {
                email: "",
                first_name: "",
                last_name: "",
                initials: "",
                studio_id: 1,
                password: ""
            }
        }
    }
}
</script>
